const routes = [
  {
    path: '/ordering/forwarders/:page?',
    props: true,
    component: () => import('@/views/ordering/forwarder/Forwarders.vue')
  }
]

export default routes
